export const downloadFromUrl = (url: string, filename: string) => {
  const link = document.createElement('a');
  link.setAttribute('download', filename);
  link.href = `${window.location.origin}${url}`;
  document.body.appendChild(link);
  link.click();
  link.remove();
};

export const convertToURL = (fileName: string) => {
  const fileURL = '/static/images';
  return `${fileURL}/${fileName}`;
};

export const constructOptions = (options: string[]) => {
  return options.map((option) => ({
    value: option,
    label: option,
  }));
};
